/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DuplicateWidgetRequestBody = {
  /**
   * The widget to copy
   */
  id: string;
};

/** @internal */
export type DuplicateWidgetRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const DuplicateWidgetRequestBody$outboundSchema: z.ZodMiniType<
  DuplicateWidgetRequestBody$Outbound,
  DuplicateWidgetRequestBody
> = z.object({
  id: z.string(),
});

export function duplicateWidgetRequestBodyToJSON(
  duplicateWidgetRequestBody: DuplicateWidgetRequestBody,
): string {
  return JSON.stringify(
    DuplicateWidgetRequestBody$outboundSchema.parse(duplicateWidgetRequestBody),
  );
}
